module.exports = __webpack_public_path__ + "static/media/SUSHI-AVAX.dfaee48f.svg";